import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import createaction from "../../context/action/category/createaction";
import Categorylist from "./categorylist";

const Category = () => {
  const { recaller, setrecaller, initDispatch, clear } =
    useContext(GlobalContext);

  const [category, setcategory] = useState();
  const [category_start_code, setcategory_start_code] = useState();
  const [error, seterror] = useState(false);
  const [error1, seterror1] = useState(false);
  return (
    <div className="min-h-screen bg-slate-50 p-6 md:p-8">
      {/* Page Header */}
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-2xl font-bold text-slate-800">کاتیگۆری</h1>
          <p className="text-sm text-slate-400 mt-0.5">بەڕێوەبردنی کاتیگۆریاکان</p>
        </div>
      </div>

      {/* Add New Category Form */}
      <div className="bg-white border border-slate-100 rounded-xl p-6 mb-6 shadow-sm">
      <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-3 gap-4 items-end">
        <div className="w-full">
          <label
            className={
              error
                ? "block text-sm font-medium text-red-500 mb-1 text-right"
                : "block text-sm font-medium text-slate-500 mb-1 text-right"
            }
            htmlFor="category"
          >
            کاتیگۆری
          </label>
          <input
            className={
              error
                ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
            }
            id="category"
            type="text"
            placeholder=""
            onClick={(val)=>{val.target.select()}}
            value={category}
            onChange={(val) => setcategory(val.target.value)}
            onFocus={() => seterror(false)}
          />
        </div>
        <div className="w-full">
          <label
            className={
              error1
                ? "block text-sm font-medium text-red-500 mb-1 text-right"
                : "block text-sm font-medium text-slate-500 mb-1 text-right"
            }
            htmlFor="category_start_code"
          >
            کۆدی دەستپێک
          </label>
          <input
            className={
              error1
                ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
            }
            id="category_start_code"
            type="text"
            placeholder=""
            onClick={(val)=>{val.target.select()}}
            value={category_start_code}
            onChange={(val) => setcategory_start_code(val.target.value)}
            onFocus={() => seterror1(false)}
          />
        </div>
        <div className="w-full">
          <button
            className="h-10 px-6 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-lg transition-colors duration-150 w-full"
            onClick={() => {
              if (category.trim() == "" || !category) {
                seterror(true);
                return false;
              }
              if (category_start_code.trim() == "" || !category_start_code) {
                seterror1(true);
                return false;
              }
              createaction(category,category_start_code)(recaller)(setrecaller)(initDispatch)(
                clear
              );
            }}
          >
            زیادکردن
          </button>
        </div>
      </div>
      </div>

      {/* Category List Section */}
      <Categorylist />
    </div>
  );
};

export default Category;
